import React from "react";
import ActionTypes from "../constants/ActionTypes";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import SvgIcon from "@material-ui/core/SvgIcon";

function Dashboard(props) {
  return (
    <SvgIcon {...props}>
      <g id="Dashboard_icon">
        <g id="Group_2" data-name="Group 2" transform="translate(-24 -6)">
          <g id="dashboard" transform="translate(27 9)">
            <path
              id="Path_23"
              data-name="Path 23"
              d="M27,23.625h1.479v3.7H27Z"
              transform="translate(-13.438 -12.282)"
              fill="#7d9eb5"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M22.5,18h1.479v7.4H22.5Z"
              transform="translate(-11.063 -10.356)"
              fill="#7d9eb5"
            />
            <path
              id="Path_25"
              data-name="Path 25"
              d="M10.448,25.4a3.7,3.7,0,0,1-3.7-3.7H8.229a2.219,2.219,0,1,0,2.219-2.219V18a3.7,3.7,0,0,1,0,7.4Z"
              transform="translate(-3.791 -10.356)"
              fill="#7d9eb5"
            />
            <path
              id="Path_26"
              data-name="Path 26"
              d="M18.964,2.25H3.536A1.287,1.287,0,0,0,2.25,3.536V18.964A1.287,1.287,0,0,0,3.536,20.25H18.964a1.287,1.287,0,0,0,1.286-1.286V3.536A1.287,1.287,0,0,0,18.964,2.25Zm0,5.786h-9v-4.5h9ZM8.679,3.536v4.5H3.536v-4.5ZM3.536,18.964V9.321H18.964v9.643Z"
              transform="translate(-2.25 -2.25)"
              fill="#7d9eb5"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

// PurchaseOrder
function PurchaseOrder(props) {
  return (
    <SvgIcon {...props}>
      <g id="PurchaseOrder_icon">
        <g id="Group_2">
          <path
            id="Path_27"
            data-name="Path 27"
            d="M20.821,6.75H3.679A1.429,1.429,0,0,0,2.25,8.179V19.607a1.429,1.429,0,0,0,1.429,1.429H20.821a1.429,1.429,0,0,0,1.429-1.429V8.179A1.429,1.429,0,0,0,20.821,6.75Zm0,1.429v2.143H3.679V8.179ZM3.679,19.607V11.75H20.821v7.857Z"
            transform="translate(0 0)"
            fill="#7d9eb5"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M6.75,22.5h7.143v1.429H6.75Z"
            transform="translate(-1.643 -5.75)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// JobIcon
function JobIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Job_icon">
        <g id="JobIcon" transform="translate(-0.25 -0.506)">
          <path
            id="Subtraction_1"
            data-name="Subtraction 1"
            d="M-101.179-117.943h-17.142a1.43,1.43,0,0,1-1.429-1.428v-12.164a1.43,1.43,0,0,1,1.429-1.428h17.142a1.43,1.43,0,0,1,1.429,1.428v12.164A1.43,1.43,0,0,1-101.179-117.943Zm-17.142-10.226v8.8h17.142v-7.942l0-3,0-1.223h-17.142v1.939h.009v1.428Z"
            transform="translate(122 139.919)"
            fill="#7d9eb5"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M6.75,22.5H20.111v1.429H6.75Z"
            transform="translate(29.893 0.925) rotate(90)"
            fill="#7d9eb5"
          />
          <path
            id="Path_37"
            data-name="Path 37"
            d="M6.75,22.5H20.111v1.429H6.75Z"
            transform="translate(40.893 0.925) rotate(90)"
            fill="#7d9eb5"
          />
        </g>
        <g
          id="Path_39"
          data-name="Path 39"
          transform="translate(7 2.53)"
          fill="none"
        >
          <path
            d="M2,0H8a2,2,0,0,1,2,2V5.315H0V2A2,2,0,0,1,2,0Z"
            stroke="none"
          />
          <path
            d="M 2 1.29999828338623 C 1.614020347595215 1.29999828338623 1.300000190734863 1.614018440246582 1.300000190734863 1.999998331069946 L 1.300000190734863 4.014958381652832 L 8.699999809265137 4.014958381652832 L 8.699999809265137 1.999998331069946 C 8.699999809265137 1.614018440246582 8.385979652404785 1.29999828338623 8 1.29999828338623 L 2 1.29999828338623 M 2 -1.430511474609375e-06 L 8 -1.430511474609375e-06 C 9.104570388793945 -1.430511474609375e-06 10 0.8954281806945801 10 1.999998331069946 L 10 5.314958095550537 L 0 5.314958095550537 L 0 1.999998331069946 C 0 0.8954281806945801 0.8954296112060547 -1.430511474609375e-06 2 -1.430511474609375e-06 Z"
            stroke="none"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

function IndentIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="IndentIcon">
        <path
          id="Path_29"
          data-name="Path 29"
          d="M22.5,6.75h7.257V8.2H22.5Z"
          transform="translate(-7.012 -0.799)"
          fill="#7d9eb5"
        />
        <path
          id="Path_30"
          data-name="Path 30"
          d="M22.5,13.5h5.08v1.451H22.5Z"
          transform="translate(-7.012 -3.194)"
          fill="#7d9eb5"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M22.5,20.25h7.257V21.7H22.5Z"
          transform="translate(-7.012 -5.59)"
          fill="#7d9eb5"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M22.5,27h5.08v1.451H22.5Z"
          transform="translate(-7.012 -7.986)"
          fill="#7d9eb5"
        />
        <path
          id="Path_33"
          data-name="Path 33"
          d="M15.75,4.5H17.2V21.917H15.75Z"
          transform="translate(-4.616)"
          fill="#7d9eb5"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M3.768,19.323l-1.023-1L7.309,13.88,2.745,9.439l1.023-1,5.6,5.443-5.6,5.443Z"
          transform="translate(0 -1.398)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}

//MastersIcon
function MastersIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Masters_icon">
        <path
          id="data-vis-1"
          d="M19.382,16.527a2.823,2.823,0,0,0-1.442.4l-2.722-2.723a3.544,3.544,0,0,0,0-3.93l1.818-1.818a2.161,2.161,0,1,0-1.009-1.01L14.21,9.269a3.544,3.544,0,0,0-3.93,0L7.556,6.546a2.823,2.823,0,0,0,.4-1.441A2.855,2.855,0,1,0,5.105,7.961a2.823,2.823,0,0,0,1.442-.4l2.722,2.723a3.544,3.544,0,0,0,0,3.93L6.546,16.932a2.824,2.824,0,0,0-1.441-.4,2.855,2.855,0,1,0,2.855,2.855,2.823,2.823,0,0,0-.4-1.442l2.723-2.722a3.547,3.547,0,0,0,1.251.523v2.345a2.142,2.142,0,1,0,1.428,0V15.741a3.547,3.547,0,0,0,1.251-.523l2.723,2.723a2.823,2.823,0,0,0-.4,1.441,2.855,2.855,0,1,0,2.855-2.855ZM12.244,10.1A2.142,2.142,0,1,1,10.1,12.244,2.142,2.142,0,0,1,12.244,10.1Zm-8.566-5A1.428,1.428,0,1,1,5.105,6.533,1.428,1.428,0,0,1,3.678,5.105Zm1.428,15.7a1.428,1.428,0,1,1,1.428-1.428A1.428,1.428,0,0,1,5.105,20.81Zm14.277,0a1.428,1.428,0,1,1,1.428-1.428A1.428,1.428,0,0,1,19.382,20.81Z"
          transform="translate(-0.244 -0.249)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}

//SafetyIcon
function SafetyIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Safety_icon">
        <path
          id="safety"
          d="M17.031,6.25a.47.47,0,0,0,.469-.469V4.219a.47.47,0,0,0-.469-.469H16.25V2.5A2.5,2.5,0,0,0,13.75,0H2.5A2.5,2.5,0,0,0,0,2.5v15A2.5,2.5,0,0,0,2.5,20H13.75a2.5,2.5,0,0,0,2.5-2.5V16.25h.781a.47.47,0,0,0,.469-.469V14.219a.47.47,0,0,0-.469-.469H16.25v-2.5h.781a.47.47,0,0,0,.469-.469V9.219a.47.47,0,0,0-.469-.469H16.25V6.25ZM15,17.5a1.254,1.254,0,0,1-1.25,1.25H2.5A1.254,1.254,0,0,1,1.25,17.5V2.5A1.254,1.254,0,0,1,2.5,1.25H13.75A1.254,1.254,0,0,1,15,2.5ZM8.125,10.625A3.125,3.125,0,1,0,5,7.5,3.124,3.124,0,0,0,8.125,10.625Zm0-5A1.875,1.875,0,1,1,6.25,7.5,1.875,1.875,0,0,1,8.125,5.625ZM9.953,11.25c-.762,0-.953.273-1.828.273S7.059,11.25,6.3,11.25a2.5,2.5,0,0,0-2.1,1.07,2.615,2.615,0,0,0-.445,1.465v1.527a.313.313,0,0,0,.313.313h.625A.313.313,0,0,0,5,15.313V13.785a1.371,1.371,0,0,1,.234-.766A1.264,1.264,0,0,1,6.3,12.5a13.85,13.85,0,0,0,1.828.273A14.076,14.076,0,0,0,9.957,12.5a1.274,1.274,0,0,1,1.066.516,1.371,1.371,0,0,1,.234.766v1.527a.313.313,0,0,0,.313.313H12.2a.313.313,0,0,0,.312-.313V13.785a2.615,2.615,0,0,0-.445-1.465A2.53,2.53,0,0,0,9.953,11.25Z"
          transform="translate(3.25 2)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}

//DamageClaimIcon
function DamageCliamIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="DamageClaim_icon">
        <g id="file-document" transform="translate(-1.75 -1.278)">
          <g
            id="Path_50"
            data-name="Path 50"
            transform="translate(-1.889 -6.611)"
            fill="#7d9eb5"
          >
            <path
              d="M 20.52778053283691 25.8055591583252 L 10.75 25.8055591583252 L 10.75 24.24999809265137 L 20.52778053283691 24.24999809265137 L 20.52778053283691 25.8055591583252 Z"
              stroke="none"
            />
            <path
              d="M 20.27778053283691 25.5555591583252 L 20.27778053283691 24.49999809265137 L 11 24.49999809265137 L 11 25.5555591583252 L 20.27778053283691 25.5555591583252 M 20.77778053283691 26.0555591583252 L 10.5 26.0555591583252 L 10.5 23.99999809265137 L 20.77778053283691 23.99999809265137 L 20.77778053283691 26.0555591583252 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
          <g
            id="Path_51"
            data-name="Path 51"
            transform="translate(-1.889 -4.722)"
            fill="#7d9eb5"
          >
            <path
              d="M 20.52778053283691 19.8055591583252 L 10.75 19.8055591583252 L 10.75 18.24999809265137 L 20.52778053283691 18.24999809265137 L 20.52778053283691 19.8055591583252 Z"
              stroke="none"
            />
            <path
              d="M 20.27778053283691 19.5555591583252 L 20.27778053283691 18.49999809265137 L 11 18.49999809265137 L 11 19.5555591583252 L 20.27778053283691 19.5555591583252 M 20.77778053283691 20.0555591583252 L 10.5 20.0555591583252 L 10.5 17.99999809265137 L 20.77778053283691 17.99999809265137 L 20.77778053283691 20.0555591583252 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
          <g
            id="Path_52"
            data-name="Path 52"
            transform="translate(-1.889 -2.833)"
            fill="#7d9eb5"
          >
            <path
              d="M 14.36111545562744 13.80555725097656 L 10.74999523162842 13.80555725097656 L 10.74999523162842 12.24999809265137 L 14.36111545562744 12.24999809265137 L 14.36111545562744 13.80555725097656 Z"
              stroke="none"
            />
            <path
              d="M 14.11111545562744 13.55555725097656 L 14.11111545562744 12.49999809265137 L 10.99999523162842 12.49999809265137 L 10.99999523162842 13.55555725097656 L 14.11111545562744 13.55555725097656 M 14.61111545562744 14.05555725097656 L 10.49999523162842 14.05555725097656 L 10.49999523162842 11.99999809265137 L 14.61111545562744 11.99999809265137 L 14.61111545562744 14.05555725097656 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
          <g
            id="Path_53"
            data-name="Path 53"
            transform="translate(0)"
            fill="#7d9eb5"
            fill-rule="evenodd"
          >
            <path
              d="M 19.91667175292969 23.3055591583252 L 7.583332061767578 23.3055591583252 C 6.021031856536865 23.3055591583252 4.750001907348633 22.0345287322998 4.750001907348633 20.47221946716309 L 4.750001907348633 6.083338737487793 C 4.750001907348633 4.521028518676758 6.021031856536865 3.249998569488525 7.583332061767578 3.249998569488525 L 15.80556201934814 3.249998569488525 C 19.63474273681641 3.249998569488525 22.75000190734863 6.365268707275391 22.75000190734863 10.19444847106934 L 22.75000190734863 20.47221946716309 C 22.75000190734863 22.0345287322998 21.47897148132324 23.3055591583252 19.91667175292969 23.3055591583252 Z M 7.583332061767578 4.805558681488037 C 6.878761768341064 4.805558681488037 6.305552005767822 5.378768444061279 6.305552005767822 6.083338737487793 L 6.305552005767822 20.47221946716309 C 6.305552005767822 21.17678833007813 6.878761768341064 21.74999809265137 7.583332061767578 21.74999809265137 L 19.91667175292969 21.74999809265137 C 20.62123107910156 21.74999809265137 21.19444274902344 21.17678833007813 21.19444274902344 20.47221946716309 L 21.19444274902344 10.19444847106934 L 21.19444274902344 9.944448471069336 L 20.94444274902344 9.944448471069336 L 15.02778148651123 9.944448471069336 L 15.02778148651123 5.055558681488037 L 15.02778148651123 4.805558681488037 L 14.77778148651123 4.805558681488037 L 7.583332061767578 4.805558681488037 Z M 16.58333206176758 4.851918697357178 L 16.58333206176758 5.15833854675293 L 16.58333206176758 8.138888359069824 L 16.58333206176758 8.388888359069824 L 16.83333206176758 8.388888359069824 L 20.51689147949219 8.388888359069824 L 20.89910125732422 8.388888359069824 L 20.74594116210938 8.038708686828613 C 20.04383277893066 6.433458805084229 18.59994125366211 5.265128612518311 16.88351249694824 4.913428783416748 L 16.58333206176758 4.851918697357178 Z"
              stroke="none"
            />
            <path
              d="M 7.583330154418945 3.499998092651367 C 6.158880233764648 3.499998092651367 5 4.658878326416016 5 6.083337783813477 L 5 20.47221755981445 C 5 21.89667892456055 6.158880233764648 23.0555591583252 7.583330154418945 23.0555591583252 L 19.91667175292969 23.0555591583252 C 21.34112167358398 23.0555591583252 22.5 21.89667892456055 22.5 20.47221755981445 L 22.5 10.19444847106934 C 22.5 6.503118515014648 19.49689102172852 3.499998092651367 15.80556106567383 3.499998092651367 L 7.583330154418945 3.499998092651367 M 21.28131103515625 8.638889312744141 L 20.51689147949219 8.638889312744141 L 16.83333206176758 8.638889312744141 L 16.33333206176758 8.638889312744141 L 16.33333206176758 8.138889312744141 L 16.33333206176758 5.15833854675293 L 16.33333206176758 4.545497894287109 L 16.93370056152344 4.66851806640625 C 18.72961044311523 5.0364990234375 20.24037170410156 6.258937835693359 20.97499084472656 7.938528060913086 L 21.28131103515625 8.638889312744141 M 15.27778053283691 9.694448471069336 L 20.94445037841797 9.694448471069336 L 21.44445037841797 9.694448471069336 L 21.44445037841797 10.19444847106934 L 21.44445037841797 20.47221755981445 C 21.44445037841797 21.31463813781738 20.75909042358398 21.99999809265137 19.91667175292969 21.99999809265137 L 7.583330154418945 21.99999809265137 C 6.740911483764648 21.99999809265137 6.055551528930664 21.31463813781738 6.055551528930664 20.47221755981445 L 6.055551528930664 6.083337783813477 C 6.055551528930664 5.24091911315918 6.740911483764648 4.555559158325195 7.583330154418945 4.555559158325195 L 14.77778053283691 4.555559158325195 L 15.27778053283691 4.555559158325195 L 15.27778053283691 5.055559158325195 L 15.27778053283691 9.694448471069336 M 7.583330154418945 2.999998092651367 L 15.80556106567383 2.999998092651367 C 19.7789421081543 2.999998092651367 23 6.221057891845703 23 10.19444847106934 L 23 20.47221755981445 C 23 22.17509841918945 21.61955070495605 23.5555591583252 19.91667175292969 23.5555591583252 L 7.583330154418945 23.5555591583252 C 5.880451202392578 23.5555591583252 4.5 22.17509841918945 4.5 20.47221755981445 L 4.5 6.083337783813477 C 4.5 4.380458831787109 5.880451202392578 2.999998092651367 7.583330154418945 2.999998092651367 Z M 19.91667175292969 21.49999809265137 C 20.48429107666016 21.49999809265137 20.94445037841797 21.03984832763672 20.94445037841797 20.47221755981445 L 20.94445037841797 10.19444847106934 L 14.77778053283691 10.19444847106934 L 14.77778053283691 5.055559158325195 L 7.583330154418945 5.055559158325195 C 7.015710830688477 5.055559158325195 6.555551528930664 5.515708923339844 6.555551528930664 6.083337783813477 L 6.555551528930664 20.47221755981445 C 6.555551528930664 21.03984832763672 7.015710830688477 21.49999809265137 7.583330154418945 21.49999809265137 L 19.91667175292969 21.49999809265137 Z M 20.51689147949219 8.138889312744141 C 19.84635162353516 6.605808258056641 18.47259140014648 5.494228363037109 16.83333206176758 5.15833854675293 L 16.83333206176758 8.138889312744141 L 20.51689147949219 8.138889312744141 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
//StockVerificationIcon
function StockVerificationIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="StockVerification_icon">
        <g id="security" transform="translate(-0.786 0.083)">
          <path
            id="Path_54"
            data-name="Path 54"
            d="M14.012,15.8l-1.788-1.788-.973.973,2.762,2.762,5.524-5.524-.973-.973Z"
            transform="translate(-2.607 -3.476)"
            fill="#7d9eb5"
          />
          <path
            id="Path_55"
            data-name="Path 55"
            d="M12.786,21.583,8.521,19.309a7.583,7.583,0,0,1-4.021-6.7V3.631A1.382,1.382,0,0,1,5.881,2.25H19.69a1.382,1.382,0,0,1,1.381,1.381v8.976a7.583,7.583,0,0,1-4.021,6.7ZM5.881,3.631v8.976a6.2,6.2,0,0,0,3.291,5.484l3.614,1.927L16.4,18.092a6.2,6.2,0,0,0,3.291-5.485V3.631Z"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

//InvoiceIcon
function InvoiceIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Invoice_icon">
        <path
          data-name="invoice_icon"
          d="M8.558,12.79,6.8,12.262a.51.51,0,0,1-.343-.5.491.491,0,0,1,.461-.515h1.1a.936.936,0,0,1,.5.145.321.321,0,0,0,.4-.029l.459-.438a.313.313,0,0,0-.022-.474,2.237,2.237,0,0,0-1.225-.443V9.062a.312.312,0,0,0-.313-.312H7.187a.312.312,0,0,0-.312.313V10a1.74,1.74,0,0,0-1.667,1.761A1.767,1.767,0,0,0,6.441,13.46l1.758.527a.51.51,0,0,1,.343.5A.491.491,0,0,1,8.081,15h-1.1a.936.936,0,0,1-.5-.145.321.321,0,0,0-.4.029l-.459.438a.313.313,0,0,0,.022.474,2.237,2.237,0,0,0,1.225.443v.949a.312.312,0,0,0,.313.312h.625a.312.312,0,0,0,.313-.312v-.942a1.739,1.739,0,0,0,1.667-1.761A1.767,1.767,0,0,0,8.558,12.79ZM2.813,3.75H7.187A.312.312,0,0,0,7.5,3.437V2.813A.312.312,0,0,0,7.187,2.5H2.813a.312.312,0,0,0-.312.313v.625A.312.312,0,0,0,2.813,3.75ZM7.5,5.937V5.313A.312.312,0,0,0,7.187,5H2.813a.312.312,0,0,0-.312.313v.625a.312.312,0,0,0,.313.313H7.187A.312.312,0,0,0,7.5,5.937Zm6.949-2.11L11.173.551A1.875,1.875,0,0,0,9.849,0H1.875A1.881,1.881,0,0,0,0,1.879V18.125A1.875,1.875,0,0,0,1.875,20H13.125A1.875,1.875,0,0,0,15,18.125V5.155a1.884,1.884,0,0,0-.551-1.328ZM10,1.273a.615.615,0,0,1,.289.164l3.277,3.277A.615.615,0,0,1,13.731,5H10ZM13.75,18.125a.627.627,0,0,1-.625.625H1.875a.627.627,0,0,1-.625-.625V1.879a.63.63,0,0,1,.625-.629H8.751V5.315a.933.933,0,0,0,.937.935H13.75Z"
          transform="translate(4.5 2)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}
// user  icon

function UserAuthentication(props) {
  return (
    <SvgIcon {...props}>
      <g id="userAuthentication" transform="translate(-9.3 -10.9)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M37.8,35.1c0,1.681,1.293,3.828,2.742,3.828,1.371,0,2.742-1.888,2.742-3.828,0-1.423-.466-3.1-2.742-3.1S37.8,33.681,37.8,35.1Z"
          transform="translate(-19.655 -14.168)"
          fill="none"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M73.407,58.6a1.6,1.6,0,0,0-3.207,0v.466h3.182V58.6Z"
          transform="translate(-43.685 -32.706)"
          fill="none"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M68.2,72.34h4.268V68.9H68.2Zm2.147-2.664a.685.685,0,0,1,.673.673.708.708,0,0,1-.362.595v.7a.287.287,0,0,1-.285.285H70.3a.287.287,0,0,1-.285-.285v-.7a.676.676,0,0,1-.362-.595A.69.69,0,0,1,70.347,69.676Z"
          transform="translate(-42.203 -41.535)"
          fill="none"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M14.22,29.386A9.549,9.549,0,0,0,20.886,32.1a9.951,9.951,0,0,0,3.152-.517.507.507,0,0,0-.336-.956,8.646,8.646,0,0,1-8.527-1.705,7.7,7.7,0,0,1,2.4-2.429,7.977,7.977,0,0,0,3.126.956,8.849,8.849,0,0,0,3.411-1.111.515.515,0,0,0-.491-.9,8.088,8.088,0,0,1-2.894.982,7.617,7.617,0,0,1-2.894-.982.6.6,0,0,0-.517,0,8.667,8.667,0,0,0-2.842,2.713,8.544,8.544,0,1,1,14.961-5.659.517.517,0,1,0,1.034,0,9.586,9.586,0,1,0-19.172,0,9.5,9.5,0,0,0,2.842,6.8C14.142,29.308,14.194,29.36,14.22,29.386Z"
          fill="#7d9eb5"
          stroke="#7d9eb5"
          stroke-width="0.1"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M33.8,32.139C33.8,34.6,35.662,37,37.577,37c1.966,0,3.777-2.328,3.777-4.863C41.353,29.5,39.982,28,37.577,28S33.8,29.5,33.8,32.139Zm6.493,0c0,1.94-1.345,3.828-2.742,3.828-1.449,0-2.742-2.147-2.742-3.828,0-1.423.466-3.1,2.742-3.1S40.293,30.716,40.293,32.139Z"
          transform="translate(-16.69 -11.202)"
          fill="#7d9eb5"
          stroke="#7d9eb5"
          stroke-width="0.1"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M67.382,53a2.65,2.65,0,0,0-2.638,2.638V56.1h-.026a.519.519,0,0,0-.517.517V61.07a.519.519,0,0,0,.517.517h5.3a.519.519,0,0,0,.517-.517V56.6a.519.519,0,0,0-.517-.517h-.026v-.466A2.622,2.622,0,0,0,67.382,53Zm-1.6,2.638a1.6,1.6,0,1,1,3.207,0V56.1H65.778ZM69.5,60.553H65.235v-3.44H69.5Z"
          transform="translate(-39.237 -29.747)"
          fill="#7d9eb5"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M74.228,73.167v.7a.287.287,0,0,0,.285.285h.078a.287.287,0,0,0,.285-.285v-.7a.676.676,0,0,0,.362-.595.673.673,0,1,0-1.345,0A.61.61,0,0,0,74.228,73.167Z"
          transform="translate(-46.42 -43.759)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}
// Reports

function Reports(props) {
  return (
    <SvgIcon {...props}>
      <g id="reports_icon">
        <g id="reports" transform="translate(-13.817 -2.024)">
          <path
            id="Path_86"
            data-name="Path 86"
            d="M33.21,7.908c0-.013-.006-.025-.009-.038a.378.378,0,0,0-.013-.04c-.005-.013-.011-.025-.017-.037a.327.327,0,0,0-.045-.071c-.005-.007-.009-.014-.015-.021L29.989,4.165l-.009-.009a.408.408,0,0,0-.032-.03l-.03-.025-.033-.021a.34.34,0,0,0-.036-.02l-.036-.013c-.012,0-.027-.009-.04-.013l-.036-.006-.046,0H19.568a1.753,1.753,0,0,0-1.751,1.751v16.5a1.753,1.753,0,0,0,1.751,1.751h11.9a1.753,1.753,0,0,0,1.751-1.751V7.978c0-.009,0-.017,0-.025a.4.4,0,0,0,0-.045ZM30.093,5.542l1.783,2.018H30.093Zm2.291,16.731a.918.918,0,0,1-.917.917h-11.9a.918.918,0,0,1-.917-.917V5.775a.918.918,0,0,1,.917-.917h9.692v3.12a.417.417,0,0,0,.417.417h2.708Z"
            transform="translate(0 0)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_87"
            data-name="Path 87"
            d="M44.87,104.123H36.3a.415.415,0,1,0,0,.829H44.87a.415.415,0,1,0,0-.829Z"
            transform="translate(-15.067 -83.392)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_88"
            data-name="Path 88"
            d="M59.461,72.992a.415.415,0,0,0,.415-.415V68.815a.415.415,0,0,0-.415-.415H57.8a.415.415,0,0,0-.415.415v3.762a.415.415,0,0,0,.415.415Zm-1.242-3.762h.827v2.933h-.827Z"
            transform="translate(-32.968 -53.626)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_89"
            data-name="Path 89"
            d="M79.108,60.684a.415.415,0,0,0,.415-.415V54.06a.415.415,0,0,0-.415-.415H77.452a.415.415,0,0,0-.415.415v6.21a.415.415,0,0,0,.415.415Zm-1.242-6.21h.827v5.381h-.827Z"
            transform="translate(-49.336 -41.325)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_90"
            data-name="Path 90"
            d="M38.156,79.648h1.657a.415.415,0,0,0,.415-.415V76.795a.415.415,0,0,0-.415-.415H38.156a.415.415,0,0,0-.415.415v2.439A.415.415,0,0,0,38.156,79.648Zm.415-2.439H39.4v1.609H38.57Z"
            transform="translate(-16.599 -60.28)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_91"
            data-name="Path 91"
            d="M42.291,37.219a1.288,1.288,0,0,0,.051.356,11.911,11.911,0,0,1-1.283.99,1.318,1.318,0,0,0-1.557-.247,1.3,1.3,0,0,0-.669,1.417c-.339.134-.684.254-1.033.357a1.314,1.314,0,0,0-1.562-.653,1.3,1.3,0,1,0,1.681,1.481,12.842,12.842,0,0,0,1.347-.464,1.317,1.317,0,0,0,1.467.163,1.3,1.3,0,0,0,.688-1.3,12.765,12.765,0,0,0,1.4-1.062,1.318,1.318,0,0,0,1.624-.051,1.292,1.292,0,0,0,.325-1.579,1.312,1.312,0,0,0-2.479.587ZM36.63,41.149a.471.471,0,1,1,.476-.471A.473.473,0,0,1,36.63,41.149Zm3.486-1.21a.471.471,0,1,1,.475-.471A.473.473,0,0,1,40.116,39.938Zm3.962-2.719a.475.475,0,1,1-.475-.471.473.473,0,0,1,.475.471Z"
            transform="translate(-14.599 -26.565)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

// audit report
function Audittrail() {
  return (
    <SvgIcon>
      <g
        id="Requirements_two"
        data-name="Requirements two"
        clipPath="url(#clip-Requirements_two)"
      >
        <g id="Contract" transform="translate(1 0.315)">
          <path
            id="Union_2"
            data-name="Union 2"
            d="M1.226,1915A1.258,1.258,0,0,1,0,1913.712v-15.427A1.258,1.258,0,0,1,1.226,1897h9.808a1.258,1.258,0,0,1,1.226,1.286v2.57H11.034v-2.57H1.226v15.427h9.943V1915Zm4.731-5.625,8.278-9.307a.949.949,0,0,1,1.372-.051l2.092,2.046H17.7a1.065,1.065,0,0,1,.048,1.44l-8.278,9.308-3.388.124Zm1.243.495.058,1.735,1.654-.06,5.588-6.277-1.719-1.68Zm6.414-7.22,1.719,1.681,1.342-1.51-1.719-1.68Zm-10.549,3.35v-1.285h4.29v1.285Zm0-3.857v-1.286H9.2v1.286Z"
            transform="translate(2 -1894.315)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

function SAPBulkUpload() {
  return (
    <SvgIcon>

      <g id="_3.reported_1" data-name="3.reported – 1" clip-path="url(#clip-_3.reported_1)">
        <g id="Group_70" data-name="Group 70">
          <g id="Group_69" data-name="Group 69" transform="translate(-1.385 -0.824)">
            <path id="Ellipse_21" data-name="Ellipse 21" d="M5,1.1A3.9,3.9,0,1,0,8.9,5,3.9,3.9,0,0,0,5,1.1M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z" transform="translate(13 11)" fill="#7d9eb5" />
            <path id="Line_52" data-name="Line 52" d="M.55,5H-.55V0H.55Z" transform="translate(18.1 14)" fill="#7d9eb5" />
            <path id="Path_231" data-name="Path 231" d="M137.784,829.422l-.705-.844,2.712-2.265a.55.55,0,0,1,.73.022l2.4,2.265-.756.8-2.041-1.929Z" transform="translate(-122 -813)" fill="#7d9eb5" />
            <path id="Path_232" data-name="Path 232" d="M140.385,836.374h-15a.55.55,0,0,1-.55-.55v-20a.55.55,0,0,1,.55-.55h15a.55.55,0,0,1,.55.55V823h-1.1v-6.629h-13.9v18.9h13.9v-.6h1.1v1.154A.55.55,0,0,1,140.385,836.374Z" transform="translate(-122 -813)" fill="#7d9eb5" />
            <text id="_" data-name="" transform="translate(5 9)" fill="#7d9eb5" font-size="5" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0"></tspan><tspan x="0" y="6"></tspan></text>
            <text id="SAP" transform="translate(4 11)" fill="#7d9eb5" font-size="7" font-family="SegoeUI-Bold, Segoe UI" font-weight="700"><tspan x="0" y="0">SAP</tspan></text>
          </g>
          <path id="Line_53" data-name="Line 53" d="M5,.55H0A.55.55,0,0,1-.55,0,.55.55,0,0,1,0-.55H5A.55.55,0,0,1,5.55,0,.55.55,0,0,1,5,.55Z" transform="translate(4 14.5)" fill="#7d9eb5" />
          <path id="Line_54" data-name="Line 54" d="M6.5.55H0A.55.55,0,0,1-.55,0,.55.55,0,0,1,0-.55H6.5A.55.55,0,0,1,7.05,0,.55.55,0,0,1,6.5.55Z" transform="translate(4 18.5)" fill="#7d9eb5" />
        </g>
      </g>
    </SvgIcon>
  );
}


function StockBulkUpload() {
  return (
    <SvgIcon>
      <g id="_3.reported_2" data-name="3.reported – 2" clip-path="url(#clip-_3.reported_2)">
        <g id="Group_73" data-name="Group 73" transform="translate(0 0)">
          <g id="Group_72" data-name="Group 72" transform="translate(-2.04 -0.168)">
            <g id="Group_71" data-name="Group 71">
              <path id="Line_52" data-name="Line 52" d="M0,7.254a.561.561,0,0,1-.6-.512V-.088A.561.561,0,0,1,0-.6a.561.561,0,0,1,.6.512V6.742A.561.561,0,0,1,0,7.254Z" transform="translate(19.929 12.5)" fill="#7d9eb5" />
              <path id="Path_231" data-name="Path 231" d="M231.471,828.043a.6.6,0,0,1-.362-1.079l4.359-3.3,3.956,3.315a.6.6,0,1,1-.771.92l-3.224-2.7-3.6,2.72A.6.6,0,0,1,231.471,828.043Z" transform="translate(-215.471 -813)" fill="#7d9eb5" />
            </g>
            <path id="Path_232" data-name="Path 232" d="M236.04,836.1h-15a.6.6,0,0,1-.6-.6V815.168a.6.6,0,0,1,.6-.6H235.79a.6.6,0,0,1,.6.6v6.792h-1.2v-6.192H221.64V834.9h14.4Z" transform="translate(-216 -813)" fill="#7d9eb5" />
          </g>
          <path id="Line_53" data-name="Line 53" d="M9,.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H9a.6.6,0,0,1,.6.6A.6.6,0,0,1,9,.6Z" transform="translate(6 5.5)" fill="#7d9eb5" />
          <path id="Line_54" data-name="Line 54" d="M9,.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H9a.6.6,0,0,1,.6.6A.6.6,0,0,1,9,.6Z" transform="translate(6 9.5)" fill="#7d9eb5" />
          <path id="Line_55" data-name="Line 55" d="M6,.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H6a.6.6,0,0,1,.6.6A.6.6,0,0,1,6,.6Z" transform="translate(6 13.5)" fill="#7d9eb5" />
          <path id="Line_56" data-name="Line 56" d="M3.5.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H3.5a.6.6,0,0,1,.6.6A.6.6,0,0,1,3.5.6Z" transform="translate(6 17.5)" fill="#7d9eb5" />
        </g>
      </g>
    </SvgIcon>
  );
}


export const Navbardata1 = {
  menus: [
    {
      text: "Dashboard",
      icon: <Dashboard />,
      link: `/${ActionTypes.LOB}/dashboard`,
    },
    

    {
      text: "Purchase Order",
      icon: <PurchaseOrder />,
      link: `/${ActionTypes.LOB}/listpurchaseorder`,
    },

    {
      text: "Inbound",
      icon: <JobIcon />,
      subMenus: [{
        text: "Job",
        icon: <JobIcon />,
        link: `/${ActionTypes.LOB}/listjob`,
      },
      {
        text: "Stock Bulk Upload",
        icon: <StockBulkUpload />,
        link: `/${ActionTypes.LOB}/databulkupload`,
      },
      {
        text: "SAP GRN Bulk Upload",
        icon: <SAPBulkUpload />,
        link: `/${ActionTypes.LOB}/sapgrnbulkupload`,
      }]
    },
    {
      text: "Outbound",
      icon: <IndentIcon />,
      subMenus: [{
        text: "Indent",
        icon: <IndentIcon />,
        link: `/${ActionTypes.LOB}/listindent`,
      },
      {
        text: "Stock Regularization",
        icon: <StockBulkUpload />,
        link: `/${ActionTypes.LOB}/stockregularization`,
      }]
    },
    {
      text: "Stock Verification",
      icon: <StockVerificationIcon />,
      link: `/${ActionTypes.LOB}/stockverificationlist`,
    },

    {
      text: "Damage Claim",
      icon: <DamageCliamIcon />,
      link: `/${ActionTypes.LOB}/damagecliamlist`,
    },

    {
      text: "Reports",
      icon: <Reports />,

      subMenus: [
        {
          text: "GRN Report",
          link: `/${ActionTypes.LOB}` + "/grnreport",
        },
        {
          text: "GI Report",
          link: `/${ActionTypes.LOB}` + "/gireport",
        },
        {
          text: "Package Level Report",
          link: `/${ActionTypes.LOB}` + "/packagelevelreport",
        },
        {
          text: "VIVO Receipt Report",
          link: `/${ActionTypes.LOB}` + "/vivoreceiptreport",
        },
        {
          text: "VIVO Issue Report",
          link: `/${ActionTypes.LOB}` + "/vivoissuereport",
        },
        {
          text: "VIVO Report",
          link: `/${ActionTypes.LOB}` + "/vivoreport",
        },
        {
          text: "Audit Report",
          link: `/${ActionTypes.LOB}/auditreport`,
        },
        {
          text: "Diversion Report",
          link: `/${ActionTypes.LOB}` + "/diversionreport",
        },
        {
          text: "SAP GRN Pending Report",
          link: `/${ActionTypes.LOB}` + "/sapgrnpendingreport",
        },
      ],
    },

    {
      text: "Safety",
      icon: <SafetyIcon />,
      subMenus: [
        {
          text: "Safety Observation",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/safetyobservationlist",
        },

        {
          text: "Safety Tools & Tackles",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/safety/toolstackleslist",
        },
        {
          text: "Safety Employee",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/list-safety-employee",
        },
        {
          text: "Equipment Compliance",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/equipment-list",
        },
        {
          text: "Spare Stock Management",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/list-sparestockmanagement",
        },
      ],
    },

    {
      text: "Invoice",
      icon: <InvoiceIcon />,
      link: `/${ActionTypes.LOB}/list-invoice`,
    },

    {
      text: "Masters",
      icon: <MastersIcon />,
      subMenus: [
        {
          text: "Customer Master",
          link: `/${ActionTypes.LOB}` + "/masters/listcustomermaster",
        },
        {
          text: "Warehouse Master",
          link: `/${ActionTypes.LOB}` + "/masters/listwarehousemaster",
        },
        {
          text: "Equipment Master",
          link: `/${ActionTypes.LOB}` + "/masters/listequipmentmaster",
        },
        {
          text: "Consignment Master",
          link: `/${ActionTypes.LOB}` + "/masters/listconsignmentmaster",
        },

        {
          text: "Employee Master",
          link: `/${ActionTypes.LOB}` + "/masters/listemployeemaster",
        },
        {
          text: "Employer Master",
          link: `/${ActionTypes.LOB}` + "/masters/listemployermaster",
        },
        {
          text: "Supplier Master",
          link: `/${ActionTypes.LOB}` + "/masters/listsuppliermaster",
        },
        {
          text: "Transporter Master",
          link: `/${ActionTypes.LOB}` + "/masters/listtransportermaster",
        },
        {
          text: "PV Category Master",
          link: `/${ActionTypes.LOB}` + "/masters/listpvcategorymaster",
        },
        {
          text: "Tools Master",
          link: `/${ActionTypes.LOB}` + "/masters/listtoolsmaster",
        },
        {
          text: "Spare Master",
          link: `/${ActionTypes.LOB}` + "/masters/listsparemaster",
        },

        {
          text: "Parameter Master",
          link: `/${ActionTypes.LOB}` + "/masters/listparametermaster",
        },
        {
          text: "Bin Master",
          link: `/${ActionTypes.LOB}` + "/masters/listbinmaster",
        },
        {
          text: "Commodity Master",
          link: `/${ActionTypes.LOB}` + "/masters/listcommoditymaster",
        },
        {
          text: "Transporter Representative Master",
          link:
            `/${ActionTypes.LOB}` +
            "/masters/listtransporterrepresentativemaster",
        },
        {
          text: "Service Master",
          link: `/${ActionTypes.LOB}` + "/masters/listvendorservicemaster",
        },
        {
          text: "Department Master",
          link: `/${ActionTypes.LOB}` + "/masters/list-department-master",
        },
        {
          text: "Consignee Master",
          link: `/${ActionTypes.LOB}` + "/masters/list-consignee-master",
        },
        {
          text: "SAP Pending Reason Master",
          link: `/${ActionTypes.LOB}` + "/masters/sappendingreasonmaster",
        },
        {
          text: "UOM Master",
          link: `/${ActionTypes.LOB}` + "/masters/list-uom-master",
        },
        {
          text: "Currency Master",
          link: `/${ActionTypes.LOB}` + "/masters/listcurrencymaster",
        },
        {
          text: "Package Type Master",
          link: `/${ActionTypes.LOB}` + "/masters/listpackagemaster",
        },
      ],
    },

    {
      text: "Config Authorization",
      icon: <UserAuthentication />,
      link: `/${ActionTypes.LOB}/listauthorization`,
    }
  ],
};


export const Navbardata2 = {
  menus: [
    {
      text: "Dashboard",
      icon: <Dashboard />,
      link: `/${ActionTypes.LOB}/dashboard`,
    },
    {
      text: "Reports",
      icon: <Reports />,

      subMenus: [
        {
          text: "GRN Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/grnreport",
        },
        {
          text: "GI Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/gireport",
        },
        {
          text: "VIVO Receipt Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/vivoreceiptreport",
        },
        {
          text: "VIVO Issue Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/vivoissuereport",
        },
        {
          text: "Diversion Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/diversionreport",
        },
        {
          text: "SAP GRN Pending Report",
          icon: <WorkOutlineIcon />,
          link: `/${ActionTypes.LOB}` + "/sapgrnpendingreport",
        },
      ],
    },
  ],
};